define("ROOM4.CCAStockInPLP.CCADisplayStockInPLP", [
  "Utils",
  "SDB.SDBLocations.Model",
  "ProductLine.Stock.View",
  "Item.Model",
], function (Utils, SDBLocationsModel, ProductLineStockView, ItemModel) {
  "use strict";

  var STOCK_STATUS_MESSAGES = {
    IN_STOCK: "In Stock & Ready To Install",
    AVAILABLE_TO_ORDER: "In Stock",
    AVAILABLE_TO_ORDER_LIMITED: "<strong>$(0)</strong> In Stock",
    OUT_OF_STOCK: "Out of Stock",
  };

  return {
    mountToApp: function mountToApp(container) {
      var LocationsModel = SDBLocationsModel.getInstance();
      var env = container.getComponent("Environment");
      var map = LocationsModel.getFieldMapper(env);

      var getCurrentLocation = function getCurrentLocation() {
        var selectedLocation = LocationsModel.getSelectedLocation();
        var selectedLocationName = selectedLocation
          ? selectedLocation.name
          : "CANADA CUSTOM AUTOWORKS LTD.";
        return selectedLocationName;
      };

      var getInternalStockField = function getInternalStockField() {
        var selectedLocationName = getCurrentLocation().toUpperCase();
        var internalLocationField = map[selectedLocationName]
          ? map[selectedLocationName].internal
          : "custitem_fedco_int_ecomm_inv";
        return internalLocationField;
      };

      var isItemStockable = function isItemStockable(parentType) {
        return (
          typeof parentType === "string" &&
          (parentType === "Tires" || parentType === "Wheels")
        );
      };

      var getInternalStocks = function getInternalStocks(model) {
        var internalStocks = [];
        var currentLocation = getCurrentLocation().toUpperCase();
        _.each(map, function (location, locationName) {
          if (locationName.toUpperCase() == currentLocation) return;
          var locationInternal = location.internal;
          var internalStock = model.attributes
            ? model.get(locationInternal) || 0
            : model[locationInternal] || 0;
          if (internalStock == 0) return;
          internalStocks.push({
            Location: locationName,
            fieldId: locationInternal,
            internalStock: internalStock,
          });
        });
        return internalStocks;
      };

      function hasInternalStockData(model) {
        var keys = Object.keys(map);
        var fieldList = keys.map(function (key) {
          return map[key].internal;
        });
        var fieldsFound = fieldList.reduce(function (acc, field) {
          return acc + (model.has(field) ? 1 : 0);
        }, 0);
        return fieldsFound > 0;
      }

      var getStockStatus = function getStockStatus(model) {
        var otherStocks = getInternalStocks(model);
        var internalStockField = getInternalStockField();
        var internalStock = model.get(internalStockField) || 0;
        var externalInventory =
          model.get("custitem_external_inventory_count") || 0;
        var vendorStock =
          otherStocks.reduce(function (acc, stock) {
            return acc + stock.internalStock;
          }, 0) + externalInventory;

        return {
          internalStock: internalStock,
          vendorStock: vendorStock,
        };
      };

      // Extend ProductLine.Stock.View to show custom stock messages in PLP
      _.extend(ProductLineStockView.prototype, {
        getContext: _.wrap(
          ProductLineStockView.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var parentView =
              this.attributes && this.attributes["data-root-component-id"];
            var parentProductType = this.model.get(
              "custitemrs_p_parent_product_type"
            );

            // Hide stock view outside PLP item cards
            if (
              parentView !== "Facets.Browse.View" ||
              !isItemStockable(parentProductType)
            ) {
              context.showStockView = false;
              return context;
            }

            // Ensure structure
            context.stockInfo = context.stockInfo || {};

            var stockStatus = getStockStatus(this.model);

            context.vendorsAvailable = stockStatus.vendorStock;

            // Reset defaults for clarity
            context.showOutOfStockMessage = false;
            context.showInStockMessage = false;
            context.isNotAvailableInStore = false;

            if (stockStatus.internalStock >= 4) {
              context.isNotAvailableInStore = false;
              context.showInStockMessage = true;
              context.stockInfo.isInStock = true;
              context.stockInfo.stock = stockStatus.internalStock;
              context.stockInfo.inStockMessage = Utils.translate(
                STOCK_STATUS_MESSAGES.IN_STOCK
              );
              return context;
            }

            var totalStock =
              stockStatus.internalStock + stockStatus.vendorStock;
            if (totalStock > 0) {
              context.isNotAvailableInStore = false;
              context.showInStockMessage = true;
              context.stockInfo.isInStock = true;
              context.stockInfo.inStockMessage =
                totalStock >= 4
                  ? Utils.translate(STOCK_STATUS_MESSAGES.AVAILABLE_TO_ORDER)
                  : Utils.translate(
                    STOCK_STATUS_MESSAGES.AVAILABLE_TO_ORDER_LIMITED,
                    totalStock
                  );
              return context;
            }

            context.showOutOfStockMessage = true;
            context.stockInfo.outOfStockMessage = Utils.translate(
              STOCK_STATUS_MESSAGES.OUT_OF_STOCK
            );
            return context;
          }
        ),
      });

      _.extend(ItemModel.prototype, {
        getStockInfo: _.wrap(ItemModel.prototype.getStockInfo, function (fn) {
          var stockInfo = fn.apply(this, _.toArray(arguments).slice(1));
          if (!hasInternalStockData(this)) {
            return stockInfo;
          }

          var parentProductType = this.get("custitemrs_p_parent_product_type");
          if (!isItemStockable(parentProductType)) {
            return stockInfo;
          }
          // fixing following fields, which affect on microlayout schema.org `availability` metadata:
          // isPurchasable - if overall stock > 0 --> true
          // isInStock - if overall stock > 0 --> true
          var stockStatus = getStockStatus(this);
          var totalStock = stockStatus.internalStock + stockStatus.vendorStock;
          stockInfo.isPurchasable = totalStock > 0;
          stockInfo.isInStock = totalStock > 0;
          return stockInfo;
        }),
      });
    },
  };
});
